import { i18n } from '../localization'

const getGreetings = () => {
  const currentDate = new Date()
  const currentOffset = currentDate.getTimezoneOffset()
  const ISTOffset = 330 // IST offset UTC +5:30
  const ISTTime = new Date(
    currentDate.getTime() + (ISTOffset + currentOffset) * 60000
  )
  // ISTTime now represents the time in IST coordinates
  const hoursIST = ISTTime.getHours()

  if (hoursIST <= 11) return i18n.t('myCustomers.goodMorning')
  else if (hoursIST <= 15) return i18n.t('myCustomers.goodAfternoon')
  return i18n.t('myCustomers.goodEvening')
}

export { getGreetings }
